// AspectRatioSlider.js
import React from 'react';
import './AspectRatioSlider.css';

const sliderValueToRatio = (value) => Math.pow(4, value / 100);
const ratioToSliderValue = (ratio) => (Math.log(ratio) / Math.log(4)) * 100;

// --- НОВЫЙ КОД: Начало ---

// 1. Задаем популярные соотношения сторон
const popularRatios = {
  square: 1,
  portraitClassic: 2 / 3,
  landscapeClassic: 3 / 2,
  portraitWide: 9 / 16,
  landscapeWide: 16 / 9,
};

// 2. Преобразуем их в значения на шкале слайдера для удобного сравнения
const snapPoints = Object.values(popularRatios).map(ratioToSliderValue);

// 3. Устанавливаем порог "прилипания" (5 единиц на шкале от -100 до 100)
const snapThreshold = 3;

// --- НОВЫЙ КОД: Конец ---


const AspectRatioSlider = ({ currentRatio, onRatioChange, onRatioApply }) => {
  const sliderValue = ratioToSliderValue(currentRatio);

  const handleSliderChange = (event) => {
    const newSliderValue = parseFloat(event.target.value);
    let newRatio;

    // --- НОВЫЙ КОД: Логика "прилипания" ---
    // Ищем ближайшую точку притяжения
    const closestSnapPoint = snapPoints.find(
      (point) => Math.abs(newSliderValue - point) < snapThreshold
    );

    if (closestSnapPoint !== undefined) {
      // Если мы рядом с популярным значением, "прилипаем" к нему
      newRatio = sliderValueToRatio(closestSnapPoint);
    } else {
      // Иначе, используем текущее значение слайдера
      newRatio = sliderValueToRatio(newSliderValue);
    }
    // --- КОНЕЦ НОВОГО КОДА ---

    onRatioChange(newRatio);
  };

  const getPreviewDimensions = (ratio) => {
    const VIEWBOX_WIDTH = 200;
    const VIEWBOX_HEIGHT = 80;
    const PADDING = 8;

    const maxWidth = VIEWBOX_WIDTH - PADDING * 2;
    const maxHeight = VIEWBOX_HEIGHT - PADDING * 2;
    
    let width, height;

    if (ratio > maxWidth / maxHeight) {
      width = maxWidth;
      height = maxWidth / ratio;
    } else {
      height = maxHeight;
      width = maxHeight * ratio;
    }

    return { 
      width, height,
      x: (VIEWBOX_WIDTH - width) / 2,
      y: (VIEWBOX_HEIGHT - height) / 2
    };
  };

  const preview = getPreviewDimensions(currentRatio);

  const getRatioText = (ratio) => {
    if (ratio >= 1) {
      return `${Math.round(ratio * 10) / 10} / 1`;
    } else {
      return `1 / ${Math.round((1 / ratio) * 10) / 10}`;
    }
  };

  const isNearSquare = currentRatio >= 1 / 1.2 && currentRatio <= 1.2;

  return (
    <div className="aspect-ratio-slider-container">
      <div className="aspect-ratio-preview">
        <svg width="200" height="80" viewBox="0 0 200 80">
          {isNearSquare && (
            <>
              {/* Левый прямоугольник (вертикальный 2:3) */}
              <g 
                className="aspect-ratio-hotkey" 
                onClick={() => {
                  onRatioChange(2/3);
                  onRatioApply(2/3);
                }}
              >
                <rect
                  x="20"
                  y={(80 - 36) / 2}
                  width="24"
                  height="36"
                  fill="transparent" 
                  stroke="var(--tg-theme-text-color)"
                  strokeWidth="2"
                  rx="4"
                  ry="4"
                />
              </g>

              {/* Правый прямоугольник (горизонтальный 3:2) */}
              <g 
                className="aspect-ratio-hotkey"
                onClick={() => {
                  onRatioChange(3/2);
                  // --- ИСПРАВЛЕНИЕ: Передавалось неверное значение ---
                  onRatioApply(3/2); 
                }}
              >
                <rect
                  x={200 - 20 - 36}
                  y={(80 - 24) / 2}
                  width="36"
                  height="24"
                  fill="transparent"
                  stroke="var(--tg-theme-text-color)"
                  strokeWidth="2"
                  rx="4"
                  ry="4"
                />
              </g>
            </>
          )}

          {/* Основной прямоугольник */}
          <rect
            width={preview.width}
            height={preview.height}
            x={preview.x}
            y={preview.y}
            fill="none"
            stroke="var(--tg-theme-text-color)"
            strokeWidth="3" 
            rx="4"
            ry="4"
            style={{ transition: 'width 0.1s ease, height 0.1s ease' }}
          />
          
          {/* Текст с текущим соотношением сторон */}
          <text
            x={preview.x + preview.width / 2}
            y={preview.y + preview.height / 2}
            fill="var(--tg-theme-button-color)"
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize="12"
            fontWeight="bold"
            fontFamily="sans-serif"
            style={{ userSelect: 'none', opacity: 0.7 }} 
          >
            {getRatioText(currentRatio)}
          </text>
        </svg>
      </div>
      <input
        type="range"
        min="-100"
        max="100"
        step="1"
        value={sliderValue}
        onChange={handleSliderChange}
        className="aspect-ratio-slider"
        // --- ИЗМЕНЕНИЕ: onRatioApply теперь принимает текущее соотношение ---
        onMouseUp={() => onRatioApply(currentRatio)}
        onTouchEnd={() => onRatioApply(currentRatio)}
      />
    </div>
  );
};

export default AspectRatioSlider;